<template>
  <BaseModal
    :is-visible="isVisible"
    :is-archivable="false"
    :is-editable="false"
    @hideModal="hideModal()"
    size="xl"
  >
    <template #header>
      <span>{{$t('routes.EXSBRefundCreate')}}</span>
    </template>
    <template #body>
      <Create :id-bank-payment="idBankPayment"></Create>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseComponents/BaseModal'
import Create from '../Create'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'CreateRefundModal',
  components: {
    BaseModal,
    Create
  },
  props: ['idBankPayment'],
  computed: {
    ...mapGetters({
      isVisible: 'exsbrefund/createModal/isVisible',
      created: 'exsbrefund/create/created'
    })
  },

  watch: {
    created (val) {
      if (val && this.isVisible) {
        this.$emit('reload')
        this.toggleModal()
      }
    }
  },

  methods: {
    hideModal () {
      this.toggleModal()
    },
    ...mapMutations({
      toggleModal: 'exsbrefund/createModal/toggleModal'
    })
  }
}
</script>

<style scoped>

</style>
